export const PROSPRATING_UNRATED = 'PROSPRATING_UNRATED'
export const PROSPRATING_DECLINED = 'PROSPRATING_DECLINED'
export const PROSPRATING_RESERVED = 'PROSPRATING_RESERVED'
export const PROSPRATING_SELECTED = 'PROSPRATING_SELECTED'
export const PROSPRATING_TOTAL = 'PROSPRATING_TOTAL'
